import { useAuthModel, useAuthFacade } from '@talbenmoshe/phrasier-auth-react-model';
import { resolveAuthNoticeContent } from '@talbenmoshe/phrasier-auth-model';
import {
  AuthSplitLayout,
  AuthPanel,
  AuthMarketingPanel,
  AuthNotice,
  OrgSlugForm,
  SsoEmailForm,
  AuthDivider,
  SocialSignInButton
} from '@talbenmoshe/phrasier-react-design-system';

const MARKETING_COPY = {
  headline: 'Say it well, the first time.',
  subhead: "Phrasier drafts your Slack and Gmail replies in your team's voice."
};

function GoogleGlyph() {
  return (
    <svg width={18} height={18} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M21.6 12.23c0-.68-.06-1.36-.18-2.02H12v3.83h5.4a4.6 4.6 0 0 1-2 3.02v2.5h3.24c1.9-1.75 3-4.33 3-7.33Z"
      />
      <path
        fill="currentColor"
        opacity={0.7}
        d="M12 22c2.7 0 4.97-.9 6.63-2.44l-3.23-2.5c-.9.6-2.05.96-3.4.96-2.6 0-4.8-1.76-5.6-4.13H3.06v2.6A10 10 0 0 0 12 22Z"
      />
    </svg>
  );
}

function requireAuthBootstrap(): NonNullable<Window['__auth_bootstrap__']> {
  if (window.__auth_bootstrap__ === undefined) {
    throw new Error('Auth bootstrap data is unavailable');
  }

  return window.__auth_bootstrap__;
}

export function AuthApp() {
  const { errorCode, orgSlugFieldValue, orgSlugFieldIsValid } = useAuthModel();
  const facade = useAuthFacade();
  const { assets } = requireAuthBootstrap();
  const notice = resolveAuthNoticeContent(errorCode);

  return (
    <AuthSplitLayout
      panel={
        <AuthPanel
          brand={{ logoSrc: assets.logo, appName: 'Phrasier' }}
          title="Sign in to Phrasier"
          subtitle="Welcome back"
          marketingCopy={MARKETING_COPY}
          notice={
            notice ? (
              <>
                <AuthNotice variant={notice.severity} title={notice.title} message={notice.message} />
                {errorCode === 'ambiguous_domain' && (
                  <OrgSlugForm
                    action="/login"
                    method="get"
                    value={orgSlugFieldValue}
                    isValid={orgSlugFieldIsValid}
                    onChange={value => facade.setOrgSlugFieldValue(value)}
                    onSubmit={() => facade.submitOrgSlug()}
                  />
                )}
              </>
            ) : undefined
          }
        >
          <SsoEmailForm action="/auth/sso" method="get" fieldName="domain" label="Work email or company domain" />
          <AuthDivider />
          <SocialSignInButton label="Continue with Google" href="/auth/google">
            <GoogleGlyph />
          </SocialSignInButton>
        </AuthPanel>
      }
      media={
        <AuthMarketingPanel
          asset={{
            imageSrc: assets.marketing1x,
            imageSrcSet: `${assets.marketing1x} 1x, ${assets.marketing2x} 2x`,
            sizes: '50vw',
            alt: ''
          }}
          copy={MARKETING_COPY}
        />
      }
    />
  );
}
